<template>
	<b-row>
		<b-col>
			<b-table-simple responsive small bordered striped table-class="mb-0">
				<b-tbody>
					<b-tr>
						<b-td><strong>INIT</strong> <small class="text-muted">Initiative</small></b-td>
						<b-td class="text-right">{{abilityMods.Dexterity+Character.Misc.Initiative|bonus}}</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-col>
	</b-row>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
	computed: {
		Character: function() {
			return this.$store.state.Character
		},
		...mapGetters('character/abilityScores',[
			'abilityMods'
		])
	}
}
</script>

<style scoped>

</style>